<template>
  <div class="function-action-container">
    <div class="event-properties-item">
      <div class="event-label">执行函数</div>
      <div>
        <div class="function-list-item" v-if="changeFunctionModule">
          <div class="function-name">{{ changeFunctionModule.name }}</div>
          <div>
            <el-button
              icon="el-icon-edit"
              circle
              title="编辑函数"
              size="mini"
            ></el-button>
            <el-button
              icon="el-icon-delete"
              circle
              title="删除函数"
              size="mini"
              @click="remove"
            ></el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="event-properties-item">
      <div class="event-label">参数</div>
      <div>
        <el-input size="mini" v-model="params"></el-input>
      </div>
    </div>
    <el-button
      icon="el-icon-plus"
      circle
      title="添加函数"
      size="mini"
      @click="dialogFunctionShow = true"
    ></el-button>

    <el-dialog
      title="添加执行的函数模块"
      :visible.sync="dialogFunctionShow"
      :modal="false"
    >
      <div class="all-function-module">
        <div
          class="function-item"
          :class="index == current ? 'select-active' : ''"
          v-for="(item, index) in functions"
          @click="changeFunction(item, index)"
        >
          <div class="name">{{ item.name }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFunctionShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    uuid: {
      type: String,
      default: "",
    },
    technology: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      token: "",
      dialogFunctionShow: false,
      functions: {},
      current: -1,
      changeFunctionModule: null,
      params: "", //参数
    };
  },
  created() {
    this.event = this.technology.getEvent(this.uuid);
    let jstoken = this.technology.jsToken;
    // 获取函数列表
    let loadFunction = this.technology.getFunctions();
    let functions = {};
    for (let key in loadFunction) {
      functions[key] = loadFunction[jstoken + "__" + key];
    }
    this.functions = functions;
    this.init();
  },
  destroyed() {
    this.saveConfig();
  },
  methods: {
    saveConfig() {
      if (this.selectFunction) {
        this.event.funcKey = this.selectFunction.key;
        this.event.funcName = this.selectFunction.name;
        this.event.value = this.selectFunction.value;
      } else {
        this.event.funcKey = this.changeFunctionModule.key;
        this.event.funcName = this.changeFunctionModule.name;
        this.event.value = this.changeFunctionModule.value;
      }
      this.event.params = this.params;
    },
    init() {
      // 显示已选的函数
      this.changeFunctionModule = {
        name: this.event.funcName,
        key: this.event.funcKey,
        value: this.event.value,
        params: this.event.params || "",
      };
      this.params = this.event.params
    },
    // 选择的处理函数
    changeFunction(item, index) {
      this.current = index;
      this.selectFunction = item;
    },
    // 删除函数
    remove() {
      this.changeFunctionModule = null;
    },
    confirm() {
      if (!this.selectFunction) {
        alert("未选择函数");
        return;
      }
      this.saveConfig();
      this.init();
      this.dialogFunctionShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.event-properties-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .event-label {
    width: 120px;
  }
}
.function-list-item {
  display: flex;
  align-items: center;
  .function-name {
    width: 120px;
  }
}
.all-function-module {
  height: 350px;
  overflow-y: auto;
  padding: 10px 15px;
  .function-item {
    cursor: pointer;
    &:hover {
      background: rgba($color: #000000, $alpha: 0.2);
    }
    .desc {
      color: #999;
    }
  }
  .select-active {
    background: rgba($color: #000000, $alpha: 0.2);
  }
}
</style>